import '../css/styles.less'
import '../js/inspinia'

// Change language

$(function() {
    $('.j-change-language').click(function() {
        $('.j-change-language-form input[name="language"]').val($(this).attr('href'));
        $('.j-change-language-form').submit();
        return false;
    });
});

// let form_general = document.getElementById("general-info");
// let initialData = {};
// Object.values(form_general).reduce((obj, field) => { obj[field.name] = field.value; return obj }, initialData);
//
// let submitForm = document.getElementById("clear");
//
// submitForm.onclick = () => {
//     for (let key in initialData) {
//         document.getElementsByName(key)[0].value = initialData[key];
//     }
// };

// order form errors

$(function() {
    const orderForm = $('.manager-order-view #createitem');
    if (orderForm.length > 0) {
        orderForm.find('.has-error').each(function () {
            const tabId = $(this).closest('.tab-pane').attr('id');
            const tabLi = orderForm.find('.nav-tabs a[href="#' + tabId + '"]').parent();
            tabLi.addClass('has-error');
        });

        const orderError = orderForm.find('.js-order-error');
        const orderErrorDetails = orderForm.find('.js-order-error-details');

        if (orderForm.find('.has-error').length == 0 && orderError.length > 0) {
            orderErrorDetails.show();
        }
    }
});

// Input file

$(function() {
    $('.custom-file-input').on('change', function () {
        let fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').addClass("selected").html(fileName);
    });
});
